/**
 * accept a number as argument and return a well formated payment string
 * @param paymentAmount number to be used to format the payment string
 */
export const formatPayment = (paymentAmount: null | number) => {
  if (paymentAmount) {
    return paymentAmount
      .toFixed(2)
      .replace(/./g, (c, i, a) => (i > 0 && c !== '.' && (a.length - i) % 3 === 0 ? `,${c}` : c));
  }
  return parseFloat('0.00').toFixed(2);
};
